import { useLingui } from "@lingui/react";
import { LOCALES, LOCALE_LABELS, type Locale } from "@sage-mcp/shared";
import { activateLocale } from "../i18n.js";

export function LanguageSelector({ id }: { id?: string }) {
  const { i18n } = useLingui();
  return (
    <select
      id={id}
      value={i18n.locale}
      onChange={(e) => activateLocale(e.target.value as Locale)}
    >
      {LOCALES.map((locale) => (
        <option key={locale} value={locale}>
          {LOCALE_LABELS[locale]}
        </option>
      ))}
    </select>
  );
}
